import React, { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { API_URL, useAxios } from "../../../utils/const";
import { useToast } from "../../../Context/ToastContext";

export const DeleteModal = ({ toggleModal, getPeriods, period }) => {

  const axiosInstance = useAxios();
  const { setToastObj } = useToast();

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      await axiosInstance.delete(`${API_URL}/periods/${period.id}`);
      getPeriods();
      setLoading(false);
      setToastObj({ msg: "Data Berhasil dihapus", type: "success" });
      closeModal();
    } catch (error) {
      let errorMessage = "Terjadi kesalahan";
      if (error.response.data.msg != undefined) {
        errorMessage = `Terjadi kesalahan, ${error.response.data.msg}`;
      } else {
        errorMessage = error.message;
      }
      setLoading(false);
      setToastObj({
        msg: errorMessage,
        type: "danger",
      });
      closeModal();
    }
  };

  const closeModal = () => toggleModal(false);

  return (
    <>
      <Modal show={toggleModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>Hapus Periode</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p className="fw-bold mb-3">
            Apakah Anda yakin akan menghapus data ini?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Batal
          </Button>
          <Button variant="danger" disabled={loading} onClick={handleSubmit}>
            {loading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )}
            <span className="ml-1">Hapus</span>
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
